import {
  ILayoutManagerUpdateStatus,
  ITableLayoutFieldManager,
} from "@defs/layout-manager";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { DropResult } from "react-beautiful-dnd";
import ticketsConfig from "@config/tickets";

interface LayoutManagerState {
  tickets: ITableLayoutFieldManager[];
}

const initialState: LayoutManagerState = {
  tickets: [],
};

const layoutManagerSlice = createSlice({
  name: "layoutManager",
  initialState,
  reducers: {
    init(state) {
      let tickets = ticketsConfig.layoutManager;

      if (window && localStorage.getItem("list_layout")) {
        // Recupero i dati si dal localstorage
        const stored = JSON.parse(localStorage.getItem("list_layout"));

        // Per evitare malfunzionamenti controllo che il dato salvato in LS
        // Sia un array, in caso non lo fosse verrà ritornata la configurazione default
        if (Array.isArray(stored)) {
          // Rimuovo tutte le colonne che non sono più presenti
          const enabled = stored.filter(
            (s: ITableLayoutFieldManager) => s.key !== "codice_cliente"
          );

          // Guardo se ci sono elementi che mancano rispetto alla configurazione
          const diff = tickets.filter((item) => {
            return !enabled.find(
              (local: ITableLayoutFieldManager) => local.key === item.key
            );
          });

          // Per poi mergiare eventuali differenze
          tickets = [...enabled, ...diff].map(({ name: _, ...rest }) => rest);
        }
      }

      state.tickets = tickets;
    },

    updateStatus(state, action: PayloadAction<ILayoutManagerUpdateStatus>) {
      const { index, active } = action.payload;
      state.tickets[index].active = active;
    },

    update(state, action: PayloadAction<DropResult>) {
      const {
        source: { index: from },
        destination: { index: to },
      } = action.payload;

      // Sposto l'elemento nella sua nuova posizione
      const { tickets } = state;

      // Lo recupero splittando l'array per l'indice di partenza
      const [item] = tickets.splice(from, 1);

      // Ricreo l'array
      tickets.splice(to, 0, item);

      // Associo il risultato allo state
      state.tickets = tickets;
    },
  },
});

export const layoutManagerActions = layoutManagerSlice.actions;

export default layoutManagerSlice.reducer;
